import React, {Component} from "react"

import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {connect} from "@irati/store"
import AuthActions from "@irati/auth/store/actions/AuthActions"
import Loading from "@irati/ui/src/Loading"
import brandingService from "@irati/brand/services/branding"
import adminTracking from "@irati-tracking/admin"
import authentication from "@irati/auth"

import EditWelcomeEmailContent from "./Content"
import SuccessWithBackLink from "../../SuccessWithBackLink"

const welcomeEmailMaxLength = 650
const WELCOME_EMAIL_KEY = "admin.components.welcomeEmail.default"

interface Props extends InjectIntl {
  updateTenant: () => void
}
interface State {
  saved: boolean,
  saving: Promise<void> | null,
  show: boolean,
  welcomeEmail: string
}

class WelcomeEmail extends Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = this.defaultState()
  }

  defaultState = () => {
    return {
      saved: false,
      saving: null,
      show: false,
      welcomeEmail: ""
    }
  }

  componentDidMount() {
    this.getWelcomeEmail()
  }

  getWelcomeEmail = () => {
    return brandingService.get({fetchPolicy: "network-only"}).then((branding) => {
      this.setState({welcomeEmail: branding.welcomeEmail || this.props.formatMessage({id: WELCOME_EMAIL_KEY})})
    })
  }

  handleWelcomeEmailChange = (e) => {
    this.setState({welcomeEmail: e || ""})
  }

  useDefault = () => {
    this.setState({welcomeEmail: ""}, () => {
      this.saveWelcomeEmail()
    })
  }

  saveWelcomeEmail = () => {
    if (this.state.welcomeEmail.length > welcomeEmailMaxLength) {
      return
    }
    const userTenant = authentication.userTenant()

    const data = {
      businessId: userTenant.uuid,
      teamId: userTenant.rootTeamId,
      welcomeEmail: this.state.welcomeEmail
    }

    const saving = brandingService.update(data).then(async(brandData) => {
      this.setState({saved: true})
      setTimeout(() => {
        this.setState(() => ({...this.defaultState(), welcomeEmail: brandData.welcomeEmail}))
        this.props.updateTenant()
      }, 2000)
    })

    adminTracking.updateWelcomeEmail()

    this.setState({saving})
  }

  getSuccessMessage() {
    const {formatMessage} = this.props
    return this.state.welcomeEmail === ""
      ? formatMessage({id: "admin.components.welcomeEmail.sendWelcomeEmail"})
      : formatMessage({id: "admin.components.welcomeEmail.updatedWelcomeEmail"})
  }

  render() {
    const {welcomeEmail, saving, saved} = this.state
    return (
      <Loading load={saving}>
        {saved ?
          <SuccessWithBackLink message={this.getSuccessMessage()} onClick={() => this.setState({saved: false})} />
          :
          (<EditWelcomeEmailContent
            welcomeEmail={welcomeEmail}
            welcomeEmailMaxLength={welcomeEmailMaxLength}
            handleWelcomeEmailChange={this.handleWelcomeEmailChange}
            useDefault={this.useDefault}
            saveWelcomeEmail={this.saveWelcomeEmail} />
          )}
      </Loading>
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateTenant: () => dispatch(AuthActions.updateTenant())
  }
}

export default injectIntl(
  connect(
    null,
    mapDispatchToProps
  )(WelcomeEmail),
  {withRef: true}
)
